// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { IsoCurrencyCode } from '@/currency/constants/iso';
import { getDepreciationScheduleReport } from '@/report/api/get-depreciation-schedule-report';
import { useQuery } from '@tanstack/react-query';
import { DateTime } from 'luxon';

export interface DepreciationScheduleReportFilters {
  startDate: string;
  endDate: string;
  itemKeys: string[];
  locationKeys: string[];
  currency: IsoCurrencyCode;
}

interface UseDepreciationScheduleReportOptions {
  filters?: DepreciationScheduleReportFilters;
}

export function useDepreciationScheduleReport(
  options: UseDepreciationScheduleReportOptions
) {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['depreciation-schedule-report', options.filters],
    queryFn: () => {
      if (!options.filters) {
        throw new Error('Depreciation schedule filters are required');
      }

      return getDepreciationScheduleReport({
        startDate: DateTime.fromISO(options.filters.startDate),
        endDate: DateTime.fromISO(options.filters.endDate),
        itemKeys: options.filters.itemKeys,
        locationKeys: options.filters.locationKeys,
        currency: options.filters.currency,
      });
    },
    enabled: options.filters !== undefined,
  });
}
